module.exports = __webpack_public_path__ + "labioplastika_5_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/labioplastika_5_after_tn.jpg
// module id = 1543
// module chunks = 0